/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ApiRequestDto } from '../model/apiRequestDto';
import { DocsRead } from '../model/docsRead';
import { Document } from '../model/document';
import { DosageFormCollection } from '../model/dosageFormCollection';
import { DrugPrice } from '../model/drugPrice';
import { DrugPriceQuote } from '../model/drugPriceQuote';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ResourceService {

    protected basePath = 'http://localhost:3402';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Deletes the saved quotes
     * 
     * @param id 
     * @param orgUnitId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceDeleteSavedQuote(id: string, orgUnitId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DrugPriceQuote>>;
    public resourceDeleteSavedQuote(id: string, orgUnitId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DrugPriceQuote>>>;
    public resourceDeleteSavedQuote(id: string, orgUnitId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DrugPriceQuote>>>;
    public resourceDeleteSavedQuote(id: string, orgUnitId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling resourceDeleteSavedQuote.');
        }

        if (orgUnitId === null || orgUnitId === undefined) {
            throw new Error('Required parameter orgUnitId was null or undefined when calling resourceDeleteSavedQuote.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }
        if (orgUnitId !== undefined && orgUnitId !== null) {
            queryParameters = queryParameters.set('orgUnitId', <any>orgUnitId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<Array<DrugPriceQuote>>(`${this.basePath}/api/Resource/DeleteSavedQuote`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return the list of all Pharmacy Communication documents that the user has access to.
     * This call only works if a valid JSON Web Token (JWT) is passed along with the request.        Sample Call      http://URL/api/Resource/DocumentRead?documentId&#x3D;Test;
     * @param documentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceDocumentRead(documentId: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public resourceDocumentRead(documentId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public resourceDocumentRead(documentId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public resourceDocumentRead(documentId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (documentId === null || documentId === undefined) {
            throw new Error('Required parameter documentId was null or undefined when calling resourceDocumentRead.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (documentId !== undefined && documentId !== null) {
            queryParameters = queryParameters.set('documentId', <any>documentId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.post<boolean>(`${this.basePath}/api/Resource/DocumentRead`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Edit saved quotes
     * 
     * @param orgUnitId 
     * @param quote 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceEditSavedQuote(orgUnitId: string, quote: DrugPriceQuote, observe?: 'body', reportProgress?: boolean): Observable<Array<DrugPrice>>;
    public resourceEditSavedQuote(orgUnitId: string, quote: DrugPriceQuote, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DrugPrice>>>;
    public resourceEditSavedQuote(orgUnitId: string, quote: DrugPriceQuote, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DrugPrice>>>;
    public resourceEditSavedQuote(orgUnitId: string, quote: DrugPriceQuote, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnitId === null || orgUnitId === undefined) {
            throw new Error('Required parameter orgUnitId was null or undefined when calling resourceEditSavedQuote.');
        }

        if (quote === null || quote === undefined) {
            throw new Error('Required parameter quote was null or undefined when calling resourceEditSavedQuote.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnitId !== undefined && orgUnitId !== null) {
            queryParameters = queryParameters.set('orgUnitId', <any>orgUnitId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<DrugPrice>>(`${this.basePath}/api/Resource/EditSavedQuote`,
            quote,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns a list of available resource groups based on the requesting user&#39;s role memberships.
     * This call only works if a valid JSON Web Token (JWT) is passed along with the request.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceGetAvailableResourceGroups(observe?: 'body', reportProgress?: boolean): Observable<Array<string>>;
    public resourceGetAvailableResourceGroups(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<string>>>;
    public resourceGetAvailableResourceGroups(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<string>>>;
    public resourceGetAvailableResourceGroups(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<string>>(`${this.basePath}/api/Resource/GetAvailableResourceGroups`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return the URL for Clinical Pharmacology with token
     * Sample Call  http://URL/api/Resource/ClinicalPharmacologyURL
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceGetClinicalPharmURL(observe?: 'body', reportProgress?: boolean): Observable<string>;
    public resourceGetClinicalPharmURL(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public resourceGetClinicalPharmURL(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public resourceGetClinicalPharmURL(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/api/Resource/ClinicalPharmacologyURL`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return the list of all specified documents that the user has access to.
     * This call only works if a valid JSON Web Token (JWT) is passed along with the request.        Sample Call      http://URL/api/Resource/GetDocuments?group&#x3D;Training
     * @param requestParams 
     * @param group 
     * @param doctype 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceGetDocuments(requestParams: ApiRequestDto, group: string, doctype?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Document>>;
    public resourceGetDocuments(requestParams: ApiRequestDto, group: string, doctype?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Document>>>;
    public resourceGetDocuments(requestParams: ApiRequestDto, group: string, doctype?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Document>>>;
    public resourceGetDocuments(requestParams: ApiRequestDto, group: string, doctype?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling resourceGetDocuments.');
        }

        if (group === null || group === undefined) {
            throw new Error('Required parameter group was null or undefined when calling resourceGetDocuments.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (group !== undefined && group !== null) {
            queryParameters = queryParameters.set('group', <any>group);
        }
        if (doctype !== undefined && doctype !== null) {
            queryParameters = queryParameters.set('doctype', <any>doctype);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<Document>>(`${this.basePath}/api/Resource/GetDocuments`,
            requestParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns a list of dosage forms and their translations
     * Sample Call  http://URL/api/Resource/GetDosageFormMapping
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceGetDosageFormMapping(observe?: 'body', reportProgress?: boolean): Observable<Array<DosageFormCollection>>;
    public resourceGetDosageFormMapping(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DosageFormCollection>>>;
    public resourceGetDosageFormMapping(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DosageFormCollection>>>;
    public resourceGetDosageFormMapping(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<DosageFormCollection>>(`${this.basePath}/api/Resource/GetDosageFormMapping`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param searchText 
     * @param facId 
     * @param dispenseAsWritten 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceGetDrugNames(searchText: string, facId: string, dispenseAsWritten: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<DrugPrice>>;
    public resourceGetDrugNames(searchText: string, facId: string, dispenseAsWritten: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DrugPrice>>>;
    public resourceGetDrugNames(searchText: string, facId: string, dispenseAsWritten: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DrugPrice>>>;
    public resourceGetDrugNames(searchText: string, facId: string, dispenseAsWritten: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (searchText === null || searchText === undefined) {
            throw new Error('Required parameter searchText was null or undefined when calling resourceGetDrugNames.');
        }

        if (facId === null || facId === undefined) {
            throw new Error('Required parameter facId was null or undefined when calling resourceGetDrugNames.');
        }

        if (dispenseAsWritten === null || dispenseAsWritten === undefined) {
            throw new Error('Required parameter dispenseAsWritten was null or undefined when calling resourceGetDrugNames.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('searchText', <any>searchText);
        }
        if (facId !== undefined && facId !== null) {
            queryParameters = queryParameters.set('facId', <any>facId);
        }
        if (dispenseAsWritten !== undefined && dispenseAsWritten !== null) {
            queryParameters = queryParameters.set('dispenseAsWritten', <any>dispenseAsWritten);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<DrugPrice>>(`${this.basePath}/api/Resource/GetDrugNames`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the prices of the drugs in the list  based on the quantity of those drugs to price
     * 
     * @param orgUnitId 
     * @param drugsToPrice 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceGetDrugPrices(orgUnitId: string, drugsToPrice: Array<DrugPrice>, observe?: 'body', reportProgress?: boolean): Observable<Array<DrugPrice>>;
    public resourceGetDrugPrices(orgUnitId: string, drugsToPrice: Array<DrugPrice>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DrugPrice>>>;
    public resourceGetDrugPrices(orgUnitId: string, drugsToPrice: Array<DrugPrice>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DrugPrice>>>;
    public resourceGetDrugPrices(orgUnitId: string, drugsToPrice: Array<DrugPrice>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnitId === null || orgUnitId === undefined) {
            throw new Error('Required parameter orgUnitId was null or undefined when calling resourceGetDrugPrices.');
        }

        if (drugsToPrice === null || drugsToPrice === undefined) {
            throw new Error('Required parameter drugsToPrice was null or undefined when calling resourceGetDrugPrices.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnitId !== undefined && orgUnitId !== null) {
            queryParameters = queryParameters.set('orgUnitId', <any>orgUnitId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<DrugPrice>>(`${this.basePath}/api/Resource/GetDrugPrices`,
            drugsToPrice,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return generic substitution for the given drug
     *     Sample Call      http://URL/api/Resource/GetGenericSubstitution  &lt;param name&#x3D;\&quot;gpi\&quot;&gt;&lt;/param&gt;&lt;param name&#x3D;\&quot;ndc\&quot;&gt;&lt;/param&gt;&lt;param name&#x3D;\&quot;facId\&quot;&gt; facility Id&lt;/param&gt;
     * @param gpi 
     * @param ndc 
     * @param facId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceGetGenericSubstitution(gpi: string, ndc: string, facId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DrugPrice>>;
    public resourceGetGenericSubstitution(gpi: string, ndc: string, facId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DrugPrice>>>;
    public resourceGetGenericSubstitution(gpi: string, ndc: string, facId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DrugPrice>>>;
    public resourceGetGenericSubstitution(gpi: string, ndc: string, facId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (gpi === null || gpi === undefined) {
            throw new Error('Required parameter gpi was null or undefined when calling resourceGetGenericSubstitution.');
        }

        if (ndc === null || ndc === undefined) {
            throw new Error('Required parameter ndc was null or undefined when calling resourceGetGenericSubstitution.');
        }

        if (facId === null || facId === undefined) {
            throw new Error('Required parameter facId was null or undefined when calling resourceGetGenericSubstitution.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (gpi !== undefined && gpi !== null) {
            queryParameters = queryParameters.set('gpi', <any>gpi);
        }
        if (ndc !== undefined && ndc !== null) {
            queryParameters = queryParameters.set('ndc', <any>ndc);
        }
        if (facId !== undefined && facId !== null) {
            queryParameters = queryParameters.set('facId', <any>facId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<DrugPrice>>(`${this.basePath}/api/Resource/GetGenericSubstitution`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return the list of all Pharmacy Communication documents that the user has access to.
     * This call only works if a valid JSON Web Token (JWT) is passed along with the request.        Sample Call      http://URL/api/Resource/GetPharmacyCommunicationDocs
     * @param requestParameters 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceGetPharmacyCommunicationDocs(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<Document>>;
    public resourceGetPharmacyCommunicationDocs(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Document>>>;
    public resourceGetPharmacyCommunicationDocs(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Document>>>;
    public resourceGetPharmacyCommunicationDocs(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling resourceGetPharmacyCommunicationDocs.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<Document>>(`${this.basePath}/api/Resource/GetPharmacyCommunicationDocs`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return the count of  Pharmacy Communication documents that the user has access to  which is not read..
     * This call only works if a valid JSON Web Token (JWT) is passed along with the request.        Sample Call      http://URL/api/Resource/GetPharmacyCommunicationDocsCount
     * @param requestParameters 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceGetPharmacyCommunicationDocsCount(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public resourceGetPharmacyCommunicationDocsCount(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public resourceGetPharmacyCommunicationDocsCount(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public resourceGetPharmacyCommunicationDocsCount(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling resourceGetPharmacyCommunicationDocsCount.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/Resource/GetPharmacyCommunicationDocsCount`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Return the list of all Pharmacy Communication documents that the user has access to.
     * This call only works if a valid JSON Web Token (JWT) is passed along with the request.        Sample Call      http://URL/api/Resource/GetPharmacyCommunicationDocsRead
     * @param requestParameters 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceGetPharmacyCommunicationDocsRead(requestParameters: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<Array<DocsRead>>;
    public resourceGetPharmacyCommunicationDocsRead(requestParameters: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DocsRead>>>;
    public resourceGetPharmacyCommunicationDocsRead(requestParameters: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DocsRead>>>;
    public resourceGetPharmacyCommunicationDocsRead(requestParameters: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParameters === null || requestParameters === undefined) {
            throw new Error('Required parameter requestParameters was null or undefined when calling resourceGetPharmacyCommunicationDocsRead.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Array<DocsRead>>(`${this.basePath}/api/Resource/GetPharmacyCommunicationDocsRead`,
            requestParameters,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns the pharmacy phone number for a given org unit ID
     * Sample Call  http://URL/api/Resource/GetPharmacyPhoneNumber?orgUnitId&#x3D;100_WHS
     * @param orgUnitId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceGetPharmacyPhoneNumber(orgUnitId: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public resourceGetPharmacyPhoneNumber(orgUnitId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public resourceGetPharmacyPhoneNumber(orgUnitId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public resourceGetPharmacyPhoneNumber(orgUnitId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnitId === null || orgUnitId === undefined) {
            throw new Error('Required parameter orgUnitId was null or undefined when calling resourceGetPharmacyPhoneNumber.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnitId !== undefined && orgUnitId !== null) {
            queryParameters = queryParameters.set('orgUnitId', <any>orgUnitId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/api/Resource/GetPharmacyPhoneNumber`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Returns all the saved quotes for drug price quote landing  page.      Sample Call      http://URL/api/Resource/GetSavedQuotes/orgUnitId&#x3D;875_WHS
     * 
     * @param orgUnitId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceGetSavedQuotes(orgUnitId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DrugPriceQuote>>;
    public resourceGetSavedQuotes(orgUnitId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DrugPriceQuote>>>;
    public resourceGetSavedQuotes(orgUnitId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DrugPriceQuote>>>;
    public resourceGetSavedQuotes(orgUnitId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnitId === null || orgUnitId === undefined) {
            throw new Error('Required parameter orgUnitId was null or undefined when calling resourceGetSavedQuotes.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnitId !== undefined && orgUnitId !== null) {
            queryParameters = queryParameters.set('orgUnitId', <any>orgUnitId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<DrugPriceQuote>>(`${this.basePath}/api/Resource/GetSavedQuotes`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param orgUnitId 
     * @param quoteName 
     * @param prices 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourcePrintDrugQuote(orgUnitId: string, quoteName: string, prices: Array<DrugPrice>, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public resourcePrintDrugQuote(orgUnitId: string, quoteName: string, prices: Array<DrugPrice>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public resourcePrintDrugQuote(orgUnitId: string, quoteName: string, prices: Array<DrugPrice>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public resourcePrintDrugQuote(orgUnitId: string, quoteName: string, prices: Array<DrugPrice>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnitId === null || orgUnitId === undefined) {
            throw new Error('Required parameter orgUnitId was null or undefined when calling resourcePrintDrugQuote.');
        }

        if (quoteName === null || quoteName === undefined) {
            throw new Error('Required parameter quoteName was null or undefined when calling resourcePrintDrugQuote.');
        }

        if (prices === null || prices === undefined) {
            throw new Error('Required parameter prices was null or undefined when calling resourcePrintDrugQuote.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnitId !== undefined && orgUnitId !== null) {
            queryParameters = queryParameters.set('orgUnitId', <any>orgUnitId);
        }
        if (quoteName !== undefined && quoteName !== null) {
            queryParameters = queryParameters.set('quoteName', <any>quoteName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/api/Resource/PrintQuote`,
            prices,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Saves the drug price quotes
     * 
     * @param orgUnitId 
     * @param quoteName 
     * @param prices 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resourceSaveQuote(orgUnitId: string, quoteName: string, prices: Array<DrugPrice>, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public resourceSaveQuote(orgUnitId: string, quoteName: string, prices: Array<DrugPrice>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public resourceSaveQuote(orgUnitId: string, quoteName: string, prices: Array<DrugPrice>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public resourceSaveQuote(orgUnitId: string, quoteName: string, prices: Array<DrugPrice>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgUnitId === null || orgUnitId === undefined) {
            throw new Error('Required parameter orgUnitId was null or undefined when calling resourceSaveQuote.');
        }

        if (quoteName === null || quoteName === undefined) {
            throw new Error('Required parameter quoteName was null or undefined when calling resourceSaveQuote.');
        }

        if (prices === null || prices === undefined) {
            throw new Error('Required parameter prices was null or undefined when calling resourceSaveQuote.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (orgUnitId !== undefined && orgUnitId !== null) {
            queryParameters = queryParameters.set('orgUnitId', <any>orgUnitId);
        }
        if (quoteName !== undefined && quoteName !== null) {
            queryParameters = queryParameters.set('quoteName', <any>quoteName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<string>(`${this.basePath}/api/Resource/SaveQuote`,
            prices,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
